import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { PresentationHandler } from 'app/services/presentation/presentationHandler';
import { Widget } from 'app/views/presentations/widgets/widget';
import { WidgetComponent } from 'app/views/presentations/widgets/widget.component';

@NgModule()
export class WidgetWrapperModule {

    public static wrapHandler(presentationHandler: Type<PresentationHandler>) {
        return {
            provide: PresentationHandler,
            useClass: presentationHandler,
            multi: true
        };
    }

    public static wrapWidget(widget: Type<Widget>): ModuleWithProviders {
        return {
            ngModule: WidgetWrapperModule,
            providers: [{
                provide: Widget,
                useClass: widget,
                multi: true
            }]
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/widgetWrapper.module.ts